module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="zmags-section wide">\n    <header class="title-field">\n        <h1>Set Up Fonts</h1>\n    </header>\n\n    <div class="tabs">\n    ';
 _.each(tabs, function (tab) { ;
__p += '\n        <span class="tab ' +
__e( tab.className ) +
' ' +
__e( tab.slug ) +
' ' +
__e( (tab.active ? 'active' : '') ) +
'" data-tab="' +
__e( tab.slug ) +
'">\n            ' +
__e( tab.name ) +
'\n        </span>\n    ';
 }) ;
__p += '\n    </div>\n\n    <div class="integrations-container" />\n\n</div>\n<footer class="default-footer"></footer>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/settings/fonts/ManageFontsIntegrationView.tpl
// module id = 3132
// module chunks = 0